import './KuecheSection.css';
import lammImg from '../../assets/images/Lamm.jpg';

function KuecheSection() {
  return (
    <section className="kueche">
      <div className="kueche__inner">
        <div className="kueche__content-col">
          <span className="kueche__label">Küche &amp; Speisekarte</span>
          <h2 className="kueche__title">Marktfrische Küche</h2>
          <div className="kueche__divider" />
          <p className="kueche__text">
            bietet ab mittags, unter dem Motto „vom Einfachen das Beste",
            ehrliche französische und toskanische Gerichte, ergänzt durch
            regionale Klassiker. Selbstverständlich sind: beste Zutaten und der
            Verzicht auf Geschmacksverstärker sowie sämtliches „Chi-Chi".
          </p>
        </div>
        <div className="kueche__image-col">
          <img src={lammImg} alt="Marktfrische Küche – Lammgericht" className="kueche__image" />
          <p className="kueche__caption">Vom Einfachen das Beste – täglich frisch &amp; regional</p>
        </div>
      </div>
    </section>
  );
}

export default KuecheSection;
